import tree from "../../../components/tree.vue"
import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
// import { emailRule } from '@/utility/index.js'

export default {
  name: "userManagement",
  components: { tree, iColumn, iTable, IPagination },
  data() {
    return {
      formInline: {
        title: '',
        username: '',
        updateTime: []
      },
      dialogVisible: false,
      height: '600',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: false,
        serialNumber: true,
      },
      columns: [
        {
          prop: "title",
          label: this.$t('PlatformSettings.executionItems'),
          align: "center",
          width: "200px"
        },
        {
          prop: "url",
          label: this.$t('PlatformSettings.executionAddress'),
          align: "center",
          width: "220px"
        },
        {
          prop: "param",
          label: this.$t('PlatformSettings.executionParameters'),
          align: "left",
          width: "300px"
        },
        {
          prop: "ip",
          label: this.$t('PlatformSettings.requestIP'),
          align: "center",
          width: "200",
        },
        {
          prop: "duration",
          label: this.$t('PlatformSettings.requestDuration'),
          align: "center",
          width: "120",
        },
        {
          prop: "result",
          label: this.$t('PlatformSettings.requestResult'),
          align: "center",
          width: "120",
          render: (h, params) => {
              return h('el-tag', {
                  props: { type: params.row.result === '' ? '' : params.row.result === '成功' ? 'success' : 'danger' }
              }, params.row.result === '' ? '' : params.row.result)
          }
        },
        {
          prop: "lastUser",
          label: this.$t('DriverManagement.operator'),
          align: "center",
          // width: "200",
        },
        {
          prop: "updateTime",
          label: this.$t('DriverManagement.operatTime'),
          align: "center",
          width: "200",
        },
      ],
      operates: {
        width: 60,
        fixed: "right",
        list: [
        ],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      // dialogFormVisible: false,
      // formLabelWidth: '100px',
      // diaTitle: '',
      // btnType: '',
      // rules: {
      //   loginName: [
      //     { required: true, message: this.$t('PlatformSettings.btn.loginName'), trigger: 'blur' },
      //   ],
      //   userName: [
      //     { required: true, message: this.$t('PlatformSettings.btn.userName'), trigger: 'blur' }
      //   ],
      //   email: [
      //     { required: true, validator: emailRule, trigger: 'blur' }
      //   ],
      //   rolePower: [
      //     { required: true, message: this.$t('PlatformSettings.btn.rolePower'), trigger: 'change' }
      //   ],
      //   expiryDate: [
      //     { required: true, message: this.$t('PlatformSettings.btn.expiryDate'), trigger: 'change' }
      //   ]
      // },
      // form: {
      //   loginName: '',
      //   userName: '',
      //   phone: '',
      //   email: '',
      //   rolePower: '',
      //   expiryDate: '',
      //   roleData: ''
      // },
      // RoleList: [],
      // dialogPowerVisible: false,
      // data: [],
      // defaultProps: {
      //   children: 'children',
      //   label: 'value',
      // },
      // keyList: [],
      // filterText: '',
      // selected: [],
      // rolePower: '',
      // companyId: '',
      // diaHidden: false,

      // isShow: true,
      // isTrue: false,
    };
  },
  // watch: {
  //   filterText(val) {
  //     this.$refs.tree.filter(val);
  //   }
  // },
  // created() {
  //   this.getRole()

  //   if (sessionStorage.getItem("userType") == 0) {
  //     this.isShow = true
  //   } else {
  //     this.isShow = false
  //   }
  // },
  mounted() {
    // console.log(this.$route.params)
    // if (this.$route.params) {
    //   this.id = this.$route.params.id
    //   this.name = this.$route.params.name
    // }
    this.getUser()
  },
  methods: {
    getUser() {
      let startTime = ''
      let endTime = ''
      if (this.formInline.updateTime) {
          if (this.formInline.updateTime.length > 0) {
              startTime = this.formInline.updateTime[0]
              endTime = this.formInline.updateTime[1]
          }
      }
      let param = {
        title: this.formInline.title,
        username: this.formInline.username,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.$store.dispatch('OperationLog/GET_QUERYLOGLIST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      })
    },
    onSearch() {
      this.currentPage = 1
      this.getUser()
    },
    onClear() {
      this.formInline = {
        title: '',
        username: '',
        updateTime: []
      }
      this.getUser()
    },
    // handleSelectionChange(val) {
    //   this.selected = val
    // },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getUser();
    },
    // addUser() {
    //   this.dialogFormVisible = true;
    //   this.diaTitle = this.$t('common.btn.add')
    //   this.btnType = 'add'
    //   this.keyList = []
    //   this.$nextTick(() => {
    //     this.$refs.form.resetFields()
    //   })

    // },
    // editUser() {
    //   this.dialogFormVisible = true;
    //   this.diaTitle = this.$t('common.btn.edit')
    //   this.btnType = 'edit'
    //   this.$nextTick(() => {
    //     this.$refs.form.clearValidate()
    //     this.form.loginName = this.selected[0].loginName
    //     this.form.userName = this.selected[0].userName
    //     this.form.phone = this.selected[0].phone
    //     this.form.email = this.selected[0].email
    //     this.form.rolePower = Number(this.selected[0].rolePower)
    //     this.form.expiryDate = this.selected[0].expiryDate
    //     this.form.roleData = this.selected[0].roleData
    //     this.keyList = []
    //     if (this.form.roleData) {
    //       var txt = this.selected[0].roleData.split(',')
    //       txt.map((item, index) => {
    //         console.log(item)
    //         this.keyList.push(item)
    //       })
    //     }

    //   })


    // },
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       let param = {
    //         userType: sessionStorage.getItem("userType"),
    //         loginName: this.form.loginName,
    //         userName: this.form.userName,
    //         phone: this.form.phone,
    //         email: this.form.email,
    //         rolePower: this.form.rolePower,
    //         expiryDate: this.form.expiryDate,
    //         roleData: this.form.roleData
    //       }
    //       if (this.btnType == 'add') {
    //         this.$store.dispatch('userManagement/GET_ADDUSER', param).then(res => {
    //           if (res.data.code == 200) {
    //             this.$message.success({
    //               message: res.data.data,
    //               duration: 6000,
    //             })
    //             this.dialogFormVisible = false;
    //             this.getUser();
    //             this.closeDia();
    //           } else {
    //             this.$message.error(res.data.msg)
    //           }

    //         }).catch(err => { })
    //       } else {
    //         param.id = this.selected[0].id
    //         this.$store.dispatch('userManagement/GET_UPDATEUSER', param).then(res => {
    //           if (res.data.code == 200) {
    //             this.$message.success(this.$t('PlatformSettings.form.editUserSuccess'))
    //             this.dialogFormVisible = false;
    //             this.getUser();
    //             this.closeDia();
    //           } else {
    //             this.$message.error(res.data.msg)
    //           }

    //         }).catch(err => { })
    //       }
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // cancle(formName) {
    //   this.dialogFormVisible = false;
    //   this.form = {
    //     loginName: '',
    //     userName: '',
    //     phone: '',
    //     email: '',
    //     rolePower: '',
    //     expiryDate: '',
    //     roleData: ''
    //   }
    // },
    // closeDia() {
    //   this.form = {
    //     loginName: '',
    //     userName: '',
    //     phone: '',
    //     email: '',
    //     rolePower: '',
    //     expiryDate: '',
    //     roleData: ''
    //   }
    //   this.dialogFormVisible = false;
    // },
    // getRole() {
    //   this.$store.dispatch('roleManagement/GET_QUERY', {}).then(res => {
    //     if (res) {
    //       if (res.data.code == 200) {
    //         this.RoleList = res.data.data
    //       }
    //     }
    //   })
    // },
    // filterNode(value, data) {
    //   if (!value) return true;
    //   return data.value.indexOf(value) !== -1;
    // },
    // getTree() {
    //   let param = {
    //     orgId: sessionStorage.getItem("roleData"),
    //     companyId: sessionStorage.getItem("companyId"),
    //   }
    //   this.$store.dispatch('tree/GET_QUERYTREE', param).then(res => {
    //     if (res) {
    //       if (res.data.code == 200) {
    //         this.data = res.data.data
    //       }
    //     }
    //   })
    // },
    // getPower() {
    //   this.dialogPowerVisible = true
    //   this.diaHidden = true
    //   this.getTree()
    //   this.$nextTick(() => {
    //   })
    // },
    // submit(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.form.roleData = this.$refs.tree.getCheckedKeys().join(',')
    //       console.log(this.form.roleData)
    //       this.dialogPowerVisible = false
    //       this.diaHidden = true
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // handCheck(currentNode, treeStatus) {
    // },
    // checkChange(val, checked) {
    // },
    // handleClose() {
    //   this.dialogPowerVisible = false
    //   this.diaHidden = false
    // },
    // deleteUser() {
    //   this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
    //     {
    //       cancelButtonText: this.$t('common.btn.cancel'),
    //       confirmButtonText: this.$t('common.btn.confirm'),
    //       type: 'warning'
    //     }).then(res => {
    //       let param = { id: this.selected[0].id }
    //       this.$store.dispatch('userManagement/GET_DELETEUSER', param).then(response => {
    //         if (response.data.code == 200) {
    //           this.getUser()
    //           this.$message.success(this.$t('common.btn.deleteSuccess'))
    //         } else {
    //           this.$message.error(response.data.msg)
    //         }
    //       }).catch(error => { })
    //     }).catch(err => {

    //     })
    // },

    // changeSort(item) {
    //   this.columns = [];
    //   this.$nextTick(function () {
    //     this.columns = item;
    //   });
    // },

    // ListSetting() {
    //   this.$refs.listSet.dialogVisible = true;
    // },
  },
};
